module.exports = __webpack_public_path__ + "static/media/15.96c2ecab.jpg";